<template>
    <div>
        <row>
            <v-col cols="12" class="d-flex align-center">
                <v-chip label color="primary">
                    Múltiple respuestas
                </v-chip>
                <v-spacer />
                <v-switch v-model="titulouse"
                    :label="titulouse == true ? 'Titulo activo' : 'Titulo inactivo'"></v-switch>
            </v-col>
            <v-col cols="12" v-if="titulouse == true">
                <v-row dense v-if="gestionEditorT">
                    <v-col cols="12" class="d-flex">
                        <v-chip label small>
                            {{ tipoOperacion }}
                        </v-chip>
                        <v-spacer />
                        <v-btn x-small icon @click="gestionEditorT = false"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12">
                        <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-end">
                        <ButtonComp v-if="evento == 'agregar'" @click="saveText(tag)" text-button="Guardar"
                            icon-but="fas fa-save" />
                    </v-col>
                </v-row>
                <v-row v-else dense>
                    <v-col cols="12">
                        <v-card outlined :style="[{ 'background-color': json_contenido.color_fondo_titulo }]">
                            <v-card-text class="d-flex justify-center">
                                <div v-html="json_contenido.titulo"></div>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-center">
                                <ButtonComp @click="activateElement('titulo')" edit-button
                                    tooltip-text="Editar titulo" />

                                <v-menu v-model="menuT" bottom origin="center center" transition="scale-transition"
                                    :close-on-content-click="false" offset-x>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-on="on" v-bind="attrs">
                                            <ButtonComp @click="activateBackground('titulo')" icon-but="fas fa-palette"
                                                classColor="primary" tooltip-text="Editar color de fondo" />
                                        </div>
                                    </template>
                                    <v-card width="300px">
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="12" class="d-flex">
                                                    <v-chip label small>
                                                        Fondo de titulo
                                                    </v-chip>
                                                    <v-spacer />
                                                    <v-btn x-small icon @click="menuT = false"><v-icon
                                                            dark>fa-times</v-icon></v-btn>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-color-picker v-model="json_contenido.color_fondo_titulo"
                                                        dot-size="12" hide-inputs
                                                        swatches-max-height="178"></v-color-picker>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-spacer />
                                                    <ButtonComp @click="saveBackground(tag); menuT = false"
                                                        text-button="Guardar" icon-but="fas fa-save" />
                                                </v-col>
                                            </v-row>
                                        </v-card-text>

                                    </v-card>


                                </v-menu>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="grey lighten-3">
                <v-row class="px-4">
                    <v-col cols="12">
                        <v-row dense v-if="gestionEditorP">
                            <v-col cols="12" class="d-flex">
                                <v-chip label small>
                                    {{ tipoOperacion }}
                                </v-chip>
                                <v-spacer />
                                <v-btn x-small icon @click="gestionEditorP = false"><v-icon
                                        dark>fa-times</v-icon></v-btn>
                            </v-col>
                            <v-col cols="12">
                                <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
                            </v-col>
                            <v-col cols="12" class="d-flex justify-end">
                                <ButtonComp v-if="evento == 'agregar'" @click="saveText(tag)" text-button="Guardar"
                                    icon-but="fas fa-save" />
                            </v-col>
                        </v-row>
                        <v-card v-else outlined class="text-center mt-2 pt-4 pb-2"
                            :style="[{ 'background-color': json_contenido.color_fondo_pregunta }]">
                            <v-card-text>
                                <div v-html="json_contenido.pregunta"></div>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-center">
                                <ButtonComp @click="activateElement('pregunta')" edit-button
                                    tooltip-text="Editar pregunta" />
                                <v-menu v-model="menuP" bottom origin="center center" transition="scale-transition"
                                    :close-on-content-click="false" offset-x>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-on="on" v-bind="attrs">
                                            <ButtonComp @click="activateBackground('pregunta')"
                                                icon-but="fas fa-palette" class-color="primary"
                                                tooltip-text="Editar color de fondo" />
                                        </div>
                                    </template>
                                    <v-card width="300px">
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="12" class="d-flex">
                                                    <v-chip label small>
                                                        Fondo de pregunta
                                                    </v-chip>
                                                    <v-spacer />
                                                    <v-btn x-small icon @click="menuP = false"><v-icon
                                                            dark>fa-times</v-icon></v-btn>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-color-picker v-model="json_contenido.color_fondo_pregunta"
                                                        dot-size="12" hide-inputs
                                                        swatches-max-height="178"></v-color-picker>
                                                </v-col>
                                                <v-col cols="12" class="d-flex justify-end">
                                                    <ButtonComp @click="saveBackground(tag); menuP = false"
                                                        text-button="Guardar" icon-but="fas fa-save" />
                                                </v-col>
                                            </v-row>
                                        </v-card-text>

                                    </v-card>
                                </v-menu>

                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="px-5">
                    <v-col cols="12" class="d-flex justify-space-between">
                        <b>Respuestas:</b>
                        <ButtonComp @click="activateElement('respuesta')" text-button="Agregar respuestas"
                            icon-but="fas fa-plus" />
                    </v-col>
                    <v-col cols="12">
                        <div v-for="(item, index) of json_contenido.respuestas" :key="item.id">
                            <v-card v-if="editing && variable == index">
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="12">
                                            <v-textarea outlined label="Editar" title="editar" v-model="item.respuesta"
                                                @keyup.enter="doneEdit()" @blur="doneEdit()" @keyup.esc="cancelEdit()"
                                                required>
                                            </v-textarea>

                                            <ButtonComp @click="doneEdit()" text-button="Editar"
                                                icon-but="fas fa-save" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-row>
                                <v-col cols="12" class="pl-3">
                                    <v-card v-show="!editing"
                                        :class="['accent-5 ma-2', item.correcta ? 'success accent-5 ma-2' : 'red accent-5 ma-2']">
                                        <v-row>
                                            <v-col cols="12" sm="10" md="10" class="pl-6">{{ item.respuesta }} </v-col>
                                            <v-col cols="12" sm="2" md="2" class="d-flex justify-center gap-10px">
                                                <ButtonComp @click="editarTarea(index)"
                                                    tooltip-text="Marcar como correcto" icon-but="fas fa-check-circle"
                                                    classColor="white" />
                                                <ButtonComp @click="editarTareaOff(index)"
                                                    tooltip-text="Marcar como incorrecto" icon-but="fas fa-times-circle"
                                                    classColor="white" />
                                                <ButtonComp @click="edit(index)" tooltip-text="Editar pregunta"
                                                    icon-but="fas fa-edit" classColor="white" />

                                                <ButtonComp @click="eliminar(index)" tooltip-text="Eliminar pregunta"
                                                    icon-but="far fa-trash-alt" classColor="white" />

                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>

                <v-row v-if="gestionRespuesta">
                    <v-col>
                        <v-textarea v-model="nuevaTarea" label="Agregar opción" @keyup.enter="agregarTarea"
                            outlined></v-textarea>
                        <ButtonComp @click="agregarTarea" text-button="Agregar" icon-but="fas fa-plus" />
                    </v-col>
                </v-row>
            </v-col>
        </row>
        <v-row class="pa-5 d-flex align-center">
            <v-card outlined>
                <v-card-text>
                    <v-radio-group v-model="json_contenido.id_dificultad" :mandatory="false">
                        <v-row dense>
                            <v-col>
                                <div cols="3" v-for="item of dificultades" :key="item.id">
                                    <v-radio :label="item.label" :color="item.color" :value="item.value"></v-radio>
                                </div>
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-text-field type="number" v-model="json_contenido.orden" label="Orden"></v-text-field>
                            </v-col>
                        </v-row>

                    </v-radio-group>
                </v-card-text>
            </v-card>
            <v-spacer />
            <ButtonComp @click="saveItem()" text-button="Guardar" icon-but="fas fa-save" />
        </v-row>

        <!-- <v-btn class="ma-2" @click="agregarTarea" color="primary" dark>Agregar <v-icon dark right>fas fa-plus-square</v-icon>  </v-btn> -->
    </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex';
import ButtonComp from "../../../../../components/ComponentsEst/TableButtonComp.vue";

export default {
    components: {
        ButtonComp
    },
    name: 'contenidoPregPM',
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
    },
    data() {
        return {
            dificultades: [
                { label: "Dificultad baja", color: "info", value: 0 },
                { label: "Dificultad media", color: "orange", value: 1 },
                { label: "Dificultad alta", color: "red", value: 2 },
            ],
            test: false,
            titulo: '',
            btn_guardar: true,
            variable: -1,
            task1: 'task',
            editing: false,
            nuevaTarea: '',
            // campos nuevos 
            compName: "",
            titulouse: false,
            estadoModalConfig: false,
            parametroConfigVisor: [],
            evento: '',
            gestorBackground: false,
            menuT: false,
            menuP: false,
            gestionEditor: false,
            gestionEditorT: false,
            gestionEditorP: false,
            gestionRespuesta: false,
            tipoOperacion: '',
            editorData: '',
            color_fondo: "#B5E6FF",
            Plantillas: [],
            json_contenido: {},
            editorConfig: {
                toolbar: [
                    ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'],
                    ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
                    ['Find', 'Replace', '-', 'SelectAll', 'RemoveFormat'],
                    ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
                    ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'],
                    ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
                    ['Link', 'Unlink', 'Anchor'],
                    ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'],
                    ['Styles', 'Format', 'Font', 'FontSize'],
                    ['TextColor', 'BGColor']
                ]
            },
        }
    },
    mounted() {
        this.loadMain()
    },
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento',
        }),
        ...mapState({
            listaPreguntasArray: state => state.gestEvaluacion.listaPreguntasArray,
        }),
    },
    watch: {
        parametros() {
            this.json_contenido.id_plantilla = this.parametros.item.id_plantilla
            this.json_contenido.id_programacion = this.parametros.item.id_programacion
            this.eventPlantilla(this.parametros.item.id_plantilla)

        },
        estadoComp() {
            if (this.estadoComp) {
                this.loadMain()
            } else {
                this.limpiarForm()
            }
        }
    },
    methods: {
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            setPushlistaPreguntas: "gestEvaluacion/setPushlistaPreguntas",
        }),
        ...mapActions({
            parametroComponente: "login/parametroComponente"
        }),
        async loadMain() {
            this.limpiarForm()
            this.getTemplate()
            this.json_contenido.id_plantilla = this.parametros.item.id_plantilla
            this.json_contenido.id_programacion = this.parametros.item.id_programacion

            if (this.parametros.evento == 'add') {
                this.calcularOrden()
            }
            if (this.parametros.evento == 'edit') {
                // console.log(`item de ediccion ${JSON.stringify(this.parametros.item.json_contenido)}`)
                this.titulouse = this.parametros.item.titulouse
                this.editItem(this.parametros.item)
            }


        },

        async editItem(items) {

            console.log(`editItem (pregPM) ${items}`)
            console.log(`editItem (pregPM) ${JSON.stringify(items)}`)

            this.json_contenido = items
            this.json_contenido.orden = items.orden
            // this.json_contenido.respuestas = respuestas
            this.json_contenido.id_usuario = sessionStorage.id
            if (!items.id_plantilla) {
                this.json_contenido.id_plantilla = -1
            }
            this.getRespuesta(items.id)

        },


        async calcularOrden() {

            if (this.parametros.evento == 'add') {

                try {
                    let params = {
                        id_colegio: this.parametros.item.id_colegio,
                        id_ano_lectivo: this.parametros.item.id_ano_lectivo,
                        id_docente: this.parametros.item.id_docente,
                        id_programacion: this.parametros.item.id_programacion
                    }

                    let resp = await axios.post(`/evaluacion/bancoPregunta/count`, { filter: params })
                    this.json_contenido.orden = resp.data + 1;
                } catch (error) {
                    console.log(error)
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                }

            }
        },


        async getTemplate() {

            try {
                let response = await axios.post(`/administrativo/contenido/getTemplate/`, { filtro: { id_colegio: sessionStorage.id_colegio, estado_template: 1, tipo: 2 } })
                this.Plantillas = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        async getRespuesta(id_pregunta) {

            // this.setEnviarMens({tipo:"W", mensaje: `Get Respuesta : ${id_pregunta}`, tiempo:null})        
            try {
                let response = await axios.get(`/evaluacion/bancoPregunta/getRepuesta/${id_pregunta}`)
                this.json_contenido.respuestas = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        agregarTarea: function () {
            if (this.nuevaTarea === '') {
                this.setEnviarMens({ tipo: "W", mensaje: 'La opción no puede estar vacia', tiempo: 4000 })
            } else {
                this.json_contenido.respuestas.push({
                    respuesta: this.nuevaTarea,
                    correcta: false
                });
                this.nuevaTarea = '';

                this.clearElement()
            }
        },

        //cambio de correcta del indice de la pregunta seleccionada -
        // se evita el error de no poder seleccionar la ultima - Alberto vega

        editarTarea: function (index) {

            this.json_contenido.respuestas[index].correcta = !this.json_contenido.respuestas[index].correcta

        },

        editarTareaOff: function (index) {
            this.json_contenido.respuestas[index].correcta = false

        },

        eliminar: function (index) {
            this.json_contenido.respuestas.splice(index, 1)
        },

        edit: function (index) {
            this.variable = index
            this.editing = true
        },

        doneEdit: function (index) {
            if (!this.task1) { this.json_contenido.respuestas.splice(index, 1); }
            this.editing = false
        },

        cancelEdit: function () {
            this.editing = false
            this.task1 = this.cacheBeforeEdit
        },
        /** 
         ___________________________________
        |  MÉTODO OBTENER PREGUNTA POR ID  */
        async getPreguntaId(idpregunta) {

            try {
                const resp = await axios.get(`/evaluacion/bancoPregunta/getPregunta/${idpregunta}`)

                let datos = resp.data
                datos.id_valor = this.parametros.item.id_valor;

                this.setPushlistaPreguntas(datos)

            } catch (e) {
                (console.error || console.log).call(console, e.stack || e);
            }

        },
        async saveItem() {
            this.btn_guardar = false
            const respTrue = this.json_contenido.respuestas.filter(item => item.correcta == true)

            if (this.json_contenido.respuestas.length == respTrue.length || respTrue.length < 2) {
                this.setEnviarMens({ tipo: "W", mensaje: 'Debes seleccionar dos o varias respuestas correctas', tiempo: 4000 })
                this.btn_guardar = true
                return false
            }

            if (this.json_contenido.orden == null || this.json_contenido.orden == "") {

                this.setEnviarMens({ tipo: "W", mensaje: 'Debe Ingresar un orden de pregunta', tiempo: 4000 })
                this.btn_guardar = true
                return false
            }

            this.btn_guardar = false
            if (this.json_contenido.titulo === '' || this.json_contenido.pregunta === '' || this.json_contenido.respuestas.length == 0) {
                this.setEnviarMens({ tipo: "W", mensaje: 'Existen campos vacios por favor complete', tiempo: 4000 })
            } else {

                try {

                    let resp = {}
                    if (this.parametros.evento == 'add') {
                        console.log(" Guardar Contenido" + this.json_contenido)
                        resp = await axios.post("/evaluacion/bancoPregunta/", this.json_contenido);
                        this.btn_guardar = true
                    }

                    if (this.parametros.evento == 'edit') {
                        resp = await axios.put("/evaluacion/bancoPregunta/" + this.json_contenido.id, this.json_contenido);
                    }

                    this.setEnviarMens({ tipo: resp.data.messageT, mensaje: resp.data.message, tiempo: 4000 })
                    console.log(resp)

                    const getIdpregunta = resp.data.data.id;
                    if (getIdpregunta) {
                        this.getPreguntaId(getIdpregunta)
                    }

                    if (resp.data.error == false) {
                        this.$emit('close')
                    }

                } catch (error) {
                    console.log(error);
                    this.btn_guardar = true
                }
            }
        },


        // FUNCIONALIDADES NUEVAS

        visorDiapositivas(item) {

            this.compName = "visorContenido"
            this.estadoModalConfig = true
            this.parametroConfigVisor = item

        },

        clearElement() {
            this.gestorBackground = false
            this.gestionEditor = false
            this.gestionRespuesta = false
        },



        activateElement(item) {

            this.clearElement()
            this.tag = item
            this.evento = "agregar"

            if (item === 'titulo') {
                this.gestionEditorT = true
                this.gestionEditorP = false
                this.tipoOperacion = 'TITULO'
                this.editorData = this.json_contenido.titulo
                this.color_fondo = this.json_contenido.color_fondo_titulo
            }

            if (item === 'pregunta') {
                this.gestionEditorP = true
                this.gestionEditorT = false
                this.tipoOperacion = 'PREGUNTA'
                this.editorData = this.json_contenido.pregunta
                this.color_fondo = this.json_contenido.color_fondo_pregunta
            }


            if (item === 'respuesta') {
                this.gestionRespuesta = true
                this.tipoOperacion = 'RESPUESTA'
                // this.editorData =  this.json_contenido.pregunta
                // this.color_fondo = this.json_contenido.color_fondo_pregunta
            }


        },


        saveText(tag) {

            if (tag === 'titulo') {
                this.json_contenido.titulo = this.editorData
                this.gestionEditorT = false
            }

            if (tag === 'pregunta') {
                this.json_contenido.pregunta = this.editorData
                this.gestionEditorP = false
            }

            if (tag === 'texto') {
                this.addColumnaText()
            }
        },



        // END edit text  //
        ////////////////////

        activateBackground(tag) {
            this.tag = tag
            this.clearElement()
            let error = true

            if (tag == "titulo") {
                this.color_fondo = this.json_contenido.color_fondo_titulo
                // this.menuT = true
                error = false
            }

            if (tag == "pregunta") {
                this.color_fondo = this.json_contenido.color_fondo_pregunta
                error = false
            }


            if (error) {
                this.setEnviarMens({ tipo: "S", mensaje: `Error interno en configuración fondo`, tiempo: null })
            } else {
                this.gestorBackground = true
            }
        },


        saveBackground(tag) {

            if (tag == "titulo") {
                this.json_contenido.color_fondo_titulo = this.color_fondo
            }

            if (tag == "pregunta") {
                this.json_contenido.color_fondo_pregunta = this.color_fondo
            }

        },




        eventPlantilla(id) {

            if (id > 0) {

                let result = this.Plantillas.filter(item => item.id == id)
                // let js =  result[0];
                let js = JSON.parse(result[0].json_contenido);
                //console.log(js.titulo)
                // console.log(js)
                // let x = JSON.parse(result[0])

                this.json_contenido.titulo = js.titulo
                this.json_contenido.pregunta = js.pregunta
                this.json_contenido.color_fondo_titulo = js.color_fondo_titulo
                this.json_contenido.color_fondo_pregunta = js.color_fondo_pregunta
                //this.json_contenido.background            = js.background

            } else {
                let orden = this.json_contenido.orden
                let id_dificultad = this.json_contenido.orden
                this.limpiarForm()
                this.json_contenido.orden = orden
                this.json_contenido.orden = id_dificultad
                this.json_contenido.id_programacion = this.parametros.item.id_programacion
            }
        },

        limpiarForm() {

            this.json_contenido = {
                id: null,
                id_colegio: sessionStorage.id_colegio,
                id_ano_lectivo: sessionStorage.id_ano_lectivo,
                id_usuario: sessionStorage.id,
                id_evaluacion: this.parametros.item.id_evaluacion,
                id_docente: this.parametros.item.id_docente,
                id_programacion: null,
                id_plantilla: -1,
                id_tipo_pregunta: 'PM',
                id_dificultad: 0,
                titulo: '<span style="font-size:36px">Ingrese un titulo</span>',
                color_fondo_titulo: "#FFFFFF",
                pregunta: '<span style="font-size:20px">Ingrese una pregunta</span>',
                color_fondo_pregunta: "#FFFFFF",
                compartir: false,
                respuestas: [],
                orden: null,
                status: true,
            }
        },

    },

}
</script>
<style scoped></style>